// FiveM Enhanced (for GTA V Enhanced) reuses the base FiveM frontend profile
// (same menu, status view and join link). The artifact/build selector is kept
// wired up on the backend (pointed at Enhanced's repo keys — see
// decline/game_profiles/fivem_enhanced.py) but its config section is HIDDEN for
// now: there are no older Enhanced builds to downgrade to yet. Drop this filter
// to expose it once versioned fivemEnhanced_* repo keys exist. See TR-5196.
import type { GameProfile, ProfileCtx } from "./types";
import fiveM from "./fiveM";

export default (ctx: ProfileCtx): Partial<GameProfile> => {
  const profile = fiveM(ctx);
  return {
    ...profile,
    configSections: profile.configSections?.filter((section) => section.props?.name !== "artifact_build"),
  };
};
